import { message } from 'utils/stringUtils';

export const DAY_REFERENCE_ARRAY = [
  {
    key: 'disabled',
    label: message('Commons:disabled')
  },
  {
    key: 'enabled',
    label: message('Commons:enabled')
  },
  {
    key: 'selected',
    label: message('Commons:selected')
  }
];
